var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagEuroSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tag-euro_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elekter---Era---Leping---Expanded",
    transform: "translate(-232.000000, -344.000000)",
    stroke: "#F0B423",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(208.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(24.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag-euro",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.705,0.749997075 L12.331,0.749997075 C11.9042171,0.749997075 11.4963435,0.926067649 11.204,1.237 L1.168,11.908 C0.881472947,12.2122105 0.731267082,12.6200353 0.752023159,13.0374211 C0.772779236,13.4548069 0.962705209,13.8457174 1.278,14.12 L11.309,22.869 C11.9370938,23.4156339 12.8849608,23.3679313 13.455,22.761 L22.834,12.744 C23.1010434,12.4591692 23.2497634,12.0834365 23.25,11.693 L23.25,2.29 C23.2494701,1.88086252 23.086364,1.48870752 22.7965913,1.19987266 C22.5068187,0.911037803 22.114137,0.749203669 21.705,0.749997075 L21.705,0.749997075 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.293,16.5 C8.318,14.525 8.318,12.344 10.293,10.369 C12.268,8.394 14.449,8.394 16.424,10.369",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.293,
    y1: 8.326,
    x2: 14.38,
    y2: 12.413,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 10.369,
    x2: 11.315,
    y2: 13.434,
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.244,
    cy: 5.45,
    r: 1.445
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagEuroSvg);
export default __webpack_public_path__ + "static/media/tag-euro_SVG.081dd2cb255d12b5af0e65a3954c747f.svg";
export { ForwardRef as ReactComponent };